import React from 'react';
import styles from './style.module.scss';

const WORDING = {
    title: "完訪數",
    table_1: [
        {
            role: "title-1",
            left: "調查地區",
            right: "完訪數",
            backgroundColor: "var(--color-pink-b)",
        },
        {
            role: "title-2",
            left: "震度四級地區",
            right: "1,562",
            backgroundColor: "var(--color-pink-d)",
        },
        {
            role: "title-3",
            left: "花蓮縣",
            right: null,
            backgroundColor: "var(--color-pink-e)",
        },
        {
            role: "text",
            left: "花蓮市",
            right: 416,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "鳳林鎮",
            right: 43,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "新城鄉",
            right: 82,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "吉安鄉",
            right: 335,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "壽豐鄉",
            right: 73,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "秀林鄉",
            right: 36,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "萬榮鄉",
            right: 31,
            backgroundColor: "white",
        },
        {
            role: "title-3",
            left: "臺東縣",
            right: null,
            backgroundColor: "var(--color-pink-e)",
        },
        {
            role: "text",
            left: "臺東市",
            right: 417,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "卑南鄉",
            right: 68,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "綠島鄉",
            right: 30,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "延平鄉",
            right: 31,
            backgroundColor: "white",
        },
    ],
    table_2: [
        {
            role: "title-1",
            left: "調查地區",
            right: "完訪數",
            backgroundColor: "var(--color-purple-b)",
        },
        {
            role: "title-2",
            left: "震度五弱以上地區",
            right: "2,002",
            backgroundColor: "var(--color-purple-d)",
        },
        {
            role: "title-3",
            left: "花蓮縣",
            right: null,
            backgroundColor: "var(--color-purple-e)",
        },
        {
            role: "text",
            left: "玉里鎮",
            right: 395,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "光復鄉",
            right: 212,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "豐濱鄉",
            right: 56,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "瑞穗鄉",
            right: 208,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "富里鄉",
            right: 180,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "卓溪鄉",
            right: 69,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "title-3",
            left: "臺東縣",
            right: null,
            backgroundColor: "var(--color-purple-e)",
        },
        {
            role: "text",
            left: "成功鎮",
            right: 205,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "關山鎮",
            right: 137,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "東河鄉",
            right: 129,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "長濱鄉",
            right: 104,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "鹿野鄉",
            right: 123,
            backgroundColor: "white",
        },
        {
            role: "text",
            left: "池上鄉",
            right: 139,
            backgroundColor: "var(--neutrals-050)",
        },
        {
            role: "text",
            left: "海端鄉",
            right: 45,
            backgroundColor: "white",
        },
    ],
};

function VisitedRateTable() {
    const table_1 = WORDING.table_1;
    const table_2 = WORDING.table_2;

    const getCellClassName = (role) => {
        const baseClass = styles.cell;
        const roleClass = styles[role.replace('-', '')]; // convert 'title-1' to 'title1'
        return `${baseClass} ${roleClass}`;
    };

    return (
        <div className={styles.container}>
            <h4>{WORDING.title}</h4>
            <div className={styles.tables}>
                {[table_1, table_2].map((table, index) => (
                    <div className={styles.table} key={`table-${index}`}>
                        {table.map((item, index) => (
                            <div
                                className={getCellClassName(item.role)}
                                key={`table-item-${index}`}
                                style={{
                                    backgroundColor: item.backgroundColor,
                                }}
                            >
                                <div>{item.left}</div>
                                <div>{item.right}</div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default VisitedRateTable;
